import {
  INVENTORIES_KEY,
  mutateInventories,
} from "@/api/inventories/useInventoriesQuery";
import { useModal } from "@/context/ModalStackManager";

import { WORK_KEY } from "@/api/work/useWorkQuery";
import { WORK_LOGS_KEY } from "@/api/workLogs/useWorkLogsQuery";
import { COMMON_TEXT } from "@/constants/text";
import { useWorkDataStore } from "@/store/work.store";
import { customNotification } from "@/utils/notificationShow";
import {
  ProductionActionApiWorksWorkIdInputPutRequest,
  WorksWorkIdInputPutRequest,
} from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useRawMaterialHandler = () => {
  const { closeModal } = useModal();

  const queryClient = useQueryClient();
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const { mutateAsync: inventoriesMutateAsync } = useMutation(
    (params: ProductionActionApiWorksWorkIdInputPutRequest) =>
      mutateInventories.workInput(params).mutationFn(undefined),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([INVENTORIES_KEY]);
        queryClient.invalidateQueries([WORK_LOGS_KEY]);
        queryClient.invalidateQueries([WORK_KEY]);
      },
    }
  );

  const onSubmit = async ({
    worksWorkIdInputPutRequest,
  }: {
    worksWorkIdInputPutRequest: WorksWorkIdInputPutRequest;
  }) => {
    try {
      await inventoriesMutateAsync({
        workId: work?.id as number,
        worksWorkIdInputPutRequest,
      });

      customNotification.success({
        message: COMMON_TEXT.NOTIFICATION.RAW_MATERIAL_INPUT_SUCCESS,
      });

      closeModal({});
    } catch (e) {
      customNotification.error({
        message: COMMON_TEXT.NOTIFICATION.RAW_MATERIAL_INPUT_FAIL,
      });
    }
  };

  return { onSubmit };
};
